import React, { Component } from "react";
import * as cookies from "../cookie.js";

import invalidpin from './invalidpin.jpg';
import logo from './assets/svg/ult-secondary-variant-lock-up-en.svg';
import gillnhl from './assets/svg/GIII_NHL_Logo_EN.svg';
import jacket from './assets/img/Header.png';
import facebook from './assets/svg/facebook.svg';
import twitter from './assets/svg/twitter.svg';
import instagram from './assets/svg/instagram.svg';
import { Link } from "react-router-dom";
export default class InvalidPinPage extends Component {
    constructor(props) {
        super(props);

        require("./app.css");

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = { value: '' };

    }

    componentDidMount() {

        cookies.checkCookie();

    }

    handleChange(event) {
        this.setState({ value: event.target.value });
    }
    handleSubmit(event) {
       // alert((this.state.value.toUpperCase()));
        window.location = './PinPage' + this.state.value.toUpperCase();

        event.preventDefault();
    }

    render() {

        return (

          <div className="app app--invalidPin">

            <header className="navigationMenu backgroundColorWhite">

              <div className="navigationMenuContents">

                <a href="/" className="navigationMenu__logo"><img src={logo} alt="logo"/></a>

                <div className="langSwitcher">
                  <a href="#" className="langSwitcher__item">EN</a>
                  <a href="/InvalidPinPagefr" className="langSwitcher__item">FR</a>
                </div>

              </div>

            </header>


                <div className="shaderWrap">

                    <div className="contentContainer contentContainer--viewport">

                        <div className="offerInfo">

                            <img src={jacket} />

                        </div>

                        <div className="productBlock">



                            <div className="pinValidation">

                                <h3 className="pinValidation__header textColorDarkBlue">Enter your pin</h3>
                                <h3 className="pinValidation__caption textColorDarkBlue">Found in select cases of Molson Ultra For A Chance to Win</h3>

                                <form onSubmit={this.handleSubmit} className="form form--pinValidation">

                                    <p className="field required form--pinValidation__pin">
                                        <input required type='text' size="6" maxLength="6" placeholder='Enter PIN Code' value={this.state.value} onChange={this.handleChange}></input>
                                    </p>

                                    <p className="field form--pinValidation__btn">
                                        <button className="btn hvr-push" value='submit'>Submit</button>
                                    </p>

                                </form>
                            </div>

                        </div>

                    </div>


              <div className="modal modal--skillTest">

                <div className="modalTitle backgroundColorBlue">
                  <h3 className="modalTitle__title">OOPS!</h3>
                </div>

                <div className="modalContents">

                  <h4 className="modalContents__invalidPin">An invalid pin was used.</h4>
                  <p className="modalContents__invalidPinInstructions">Either this PIN has been previously used or has been typed incorrectly. Please ensure the PIN is typed exactly as seen on the card.</p>
                  <h5 className="modalContents__support">Having issues?<br></br>Contact Customer service:<br></br>1-800-MOLSON1</h5>

                  <a href="/PinPage" className="btn hvr-push">Close</a>

                </div>

              </div>

            </div>

            <footer className="footer backgroundColorRed">

              <div className="footerContents">

                <ul className="footerSocials">

                  <li className="footerSocials__item">
                    <a href="https://www.facebook.com/MolsonUltra" target="_blank">
                      <img src={facebook}/>
                    </a>
                  </li>

                  <li className="footerSocials__item">
                    <a href="https://twitter.com/molsonultra" target="_blank">
                      <img src={twitter}/>
                    </a>
                  </li>

                  <li className="footerSocials__item">
                    <a href="https://www.instagram.com/molsonultra/?hl=en" target="_blank">
                      <img src={instagram}/>
                    </a>
                  </li>

                </ul>

                <ul className="footerLinks">

                  <li className="footerLinks__item">
                    <a href="/TermsPage">Terms & Conditions</a>
                  </li>



                  <li className="footerLinks__item">
                    <a href="/ContactPage">Contact Us</a>
                  </li>

                </ul>

              </div>

            </footer>

          </div>

        )

    };
}
